import { render, staticRenderFns } from "./colonelInfo.vue?vue&type=template&id=0db2b078&scoped=true"
import script from "./colonelInfo.vue?vue&type=script&lang=js"
export * from "./colonelInfo.vue?vue&type=script&lang=js"
import style0 from "./colonelInfo.vue?vue&type=style&index=0&id=0db2b078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db2b078",
  null
  
)

export default component.exports